import { SET_CONTROL } from '../constants/actionTypes';

export default (control = [], action) => {
    switch (action.type) {
        case SET_CONTROL:
            return action.payload;
        default:
            return control;
    }
}